import React, { useState, useEffect } from 'react';
import { useAdManager } from '../hooks/useAdManager';
import { STokenLogo } from './StreamDisplay';
import './AdRewardButton.css';

export default function AdRewardButton() {
  const {
    ready,
    canShowRewarded,
    adsRemaining,
    cooldownLeft,
    rewardState,
    lastReward,
    showRewardedAd,
  } = useAdManager();

  // Live cooldown countdown (ticks every second while cooling down)
  const [cooldownDisplay, setCooldownDisplay] = useState(0);
  useEffect(() => {
    if (cooldownLeft <= 0) { setCooldownDisplay(0); return; }
    setCooldownDisplay(Math.ceil(cooldownLeft / 1000));
    const t = setInterval(() => {
      setCooldownDisplay(s => {
        if (s <= 1) { clearInterval(t); return 0; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [cooldownLeft]);

  const onCooldown = cooldownDisplay > 0;
  const disabled   = !canShowRewarded || rewardState === 'loading';

  const cooldownLabel = cooldownDisplay >= 60
    ? `${Math.ceil(cooldownDisplay / 60)}m`
    : `${cooldownDisplay}s`;

  return (
    <button
      className={`ad-reward-btn ad-reward-btn--${rewardState}${disabled ? ' ad-reward-btn--disabled' : ''}`}
      onClick={showRewardedAd}
      disabled={disabled}
      aria-label="Watch ad to earn Streams"
    >
      <div className="ad-reward-btn__glow" />

      {rewardState === 'success' && (
        <div className="ad-reward-btn__content">
          <span className="ad-reward-btn__check">✓</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            +{lastReward} <STokenLogo size={14} /> earned!
          </span>
        </div>
      )}

      {rewardState === 'skipped' && (
        <div className="ad-reward-btn__content">
          <span>Ad skipped — no reward</span>
        </div>
      )}

      {rewardState === 'error' && (
        <div className="ad-reward-btn__content">
          <span>Ad unavailable — try again</span>
        </div>
      )}

      {rewardState === 'loading' && (
        <div className="ad-reward-btn__content">
          <span className="ad-reward-btn__spinner" />
          <span>Loading ad...</span>
        </div>
      )}

      {rewardState === 'idle' && (
        <div className="ad-reward-btn__content">
          {onCooldown ? (
            <>
              <span className="ad-reward-btn__play" style={{ opacity: 0.4 }}>▶</span>
              <div className="ad-reward-btn__text">
                <span className="ad-reward-btn__label">Next ad in {cooldownLabel}</span>
                <span className="ad-reward-btn__sub">{adsRemaining} of 15 remaining today</span>
              </div>
            </>
          ) : adsRemaining === 0 ? (
            <>
              <span className="ad-reward-btn__play" style={{ opacity: 0.4 }}>▶</span>
              <div className="ad-reward-btn__text">
                <span className="ad-reward-btn__label">Daily limit reached</span>
                <span className="ad-reward-btn__sub">Resets at midnight</span>
              </div>
            </>
          ) : (
            <>
              <span className="ad-reward-btn__play">▶</span>
              <div className="ad-reward-btn__text">
                <span className="ad-reward-btn__label">Watch Ad</span>
                <span className="ad-reward-btn__reward">
                  <STokenLogo size={13} />
                  +10–25 Streams · {adsRemaining} left today
                </span>
              </div>
              {!ready && <span className="ad-reward-btn__loading-dot" />}
            </>
          )}
        </div>
      )}
    </button>
  );
}
